/* http://docs-next.angularjs.org/api/angular.module.ng.$compileProvider.directive */


angular.module('jv.directives', [])

/**
 * jv:helptext directive is used to show help icon and on click of it showing the help text.
 * The expression takes several params just like a normal function, comma-separated
 * NOTE: Make sure you add {CLOSE} to the i18n in-page variables
 *
 * @param body {string}
 * @param [title] {string} Optional title text
 * @param [classes] {string} Optional additional classes to apply to the container
 **/
.directive('jvHelptext', [function() {
    return function(scope, linkElement, attrs) {
        var result = '',
            classes = 'help-content ui-hide',
            data = scope.$eval('['+attrs.jvHelptext+']'),
            close = scope.i18n.CLOSE || '',
            view = null;

        if (!data[0]) {
            return;
        }

        if (data[2]) {
            classes += data[2];
        }

        result += '<a class="help" title="' + data[1] + '">' + data[1] + '</a>';
        result += '<div class="' + classes + '">';

        if ( data[1] ) {
            result += '<h4><a title="'+close+'">[x]</a>'+data[1]+'</h4>';
        } else {
            result += '<h4><a title="'+close+'">[x]</a></h4>';
        }

        result += data[0] + '</div>';

        view = angular.element(result);

        linkElement.append(view);
        linkElement.find('a.help').click(function(e) {
            e.preventDefault();
            tooltip = linkElement.find('.help-content');
            tooltip.removeClass('ui-hide');
            $('.help-content').not(tooltip).addClass('ui-hide');
        });
        linkElement.find('.help-content h4 a').click(function(e) {
            e.preventDefault();
            linkElement.find('.help-content').addClass('ui-hide');
        });
    };
}])



// select2 in the modal dialog.
/**
 *  Using this directive you need three attributes.
 *      i)  'what-to-watch' :  (Array) REQUIRED ->  This will be used as the data for the select2.
 *      ii) 'what-to-change': (String) REQUIRED ->  What key should be changed in scope to reflect the change in select2.
 *      iii)'what-is-text'  : (String) REQUIRED ->  This will be used as the 'key' for displaying text in the object provided by 'what-to-watch'. (select2 uses 'text' as the key by default)
        iv) 'what-is-id': (String) OPTIONAL: -> default is id. you can specify your own id key for the select2.
        NOTE: if you are setting the default value for the select 2 then 'what-is-id' is required.
 */
.directive('jvModalSelect2', ['$timeout', '$filter', function($timeout, $filter){

    var linker = function(scope, element, attribute){

        var hiddenField = angular.element("<input style='"+ attribute['style'] +"' type=\"hidden\" />");
        element.append(hiddenField);
        var firstRun = true;
        function buildResetObj() {
            var resetObj = {};
            if(angular.isDefined(attribute.jvPlaceholder)) {
                var possibles = $filter('filter')(scope.whatToWatch, function(value) {
                    return value[attribute.whatIsText] === attribute.jvPlaceholder;
                });
                if (possibles.length === 1) {
                    resetObj = possibles[0];
                } else {
                    resetObj[attribute.whatIsId] = '';
                    resetObj[attribute.whatIsText] = attribute.jvPlaceholder;
                }
            }else {
                if(firstRun && (scope.whatToChange != null) && angular.isDefined(scope.whatToChange)){
                    resetObj = scope.whatToChange;
                } else {
                    resetObj = scope.whatToWatch[0];
                }
                firstRun = false;
            }
            return resetObj;
        }
        function renderSelect2(){
            // If there is another way you want to show the text.
            function format(item){
                return item[attribute['whatIsText']];
            }

            var options = angular.copy(window._jvPluginDefaults.select2) || {};
            if (angular.isDefined(attribute.jvAllowClear)) {
                options.allowClear = !!attribute.jvAllowClear;
            }
            if (angular.isDefined(attribute.jvPlaceholder)) {
                options.placeholder = attribute.jvPlaceholder;
            }

            options.formatSelection = scope.formatSelection || format;
            options.formatResult = scope.formatResult || format;
            options.id = function(state){
                return state[attribute['whatIsId']] || state['id'];
            };
            options.data = {
                results: scope['whatToWatch'],
                text: attribute['whatIsText']
            };
            options.initSelection = function(element, callback) {
                if(angular.isObject(scope.whatToChange)) {
                    callback(scope.whatToChange);
                }
                else if (options.allowClear && scope.whatToChange === null) {
                    callback(null);
                }
                else {
                    callback(scope.whatToWatch[0]);
                }
            };

            $(hiddenField).select2(options).on('change', function( event ){
                    scope.$apply(function(scope){
                        if(event.val === '' || angular.isUndefined(scope.whatToChange) || scope.whatToChange==null) {
                            scope.whatToChange = buildResetObj( );
                        } else {
                            for(var i = 0, j=scope['whatToWatch'].length; i<j;i++){
                                if( scope['whatToWatch'][i][   attribute['whatIsId']  ] == event.val){
                                    scope['whatToChange'] = scope['whatToWatch'][i];
                                    break;
                                }
                            }
                        }
                    });
                });

//          $(element).select2('val',scope['whatToWatch'][0]);
//          scope['whatToChange'] = scope['whatToWatch'][0];
            // use time out for setting the value so you know that apply will always be applied.
            $timeout(function(){
                // set the initial value as the first one in the result list. Below doesnt work.
                //$(element).select2('data',scope['whatToWatch'][0]);
                //https://github.com/ivaynberg/select2/issues/49
                var newVal = buildResetObj();
                $(hiddenField).val(newVal);
//              scope['whatToChange'] = newVal;
                $(hiddenField).trigger('change');
            }, 300);

            if(scope['setToDisabled'] === 'true'){
                $(hiddenField).select2('disable');
            }
        }

        scope.$watch('whatToWatch', function(newValue, oldValue){
            if(angular.isDefined(newValue) && newValue.length>0){
                renderSelect2();
            }
        });

//      scope.$watch('whatToChange', function(newValue, oldValue){
//          if(angular.isUndefined(newValue) || newValue == null){
//              return;
//          }
//
//          $(hiddenField).val(newVal);
//      });
    };

    return{
        restrict: 'A',
        scope:{
            'whatToWatch':'=whatToWatch',
            'whatToChange': '=whatToChange',
            'whatIsText':'@whatIsText',
            'whatIsId': '@whatIsId',
            'setToDisabled': '@',
            'formatSelection': '=',
            'formatResult': '='
        },
        link: linker
    };
}])
.directive('jvTableDragDrop', [function(){
    return{
        restrict: 'A',
        link: function(scope, elem, attr){
            $(elem).sortable({
                update: function(e, ui){
                    scope.moveObject(ui.item);
                },
                start: function(e, ui){
                },
                helper: function(e, ui)
                {
                    var originals = ui.children();
                    var helper = ui.clone();
                    helper.children().each(function(index){
                        $(this).width(originals.eq(index).width());
                    });
                    return helper;
                }
            });
        }
    };
}])

.directive('jvObjectData', [function(){
    return {
        priority: 99, // it needs to run after the attributes are interpolated
        compile: function(elem, attr){
            var data = elem.html();
            var view = angular.element('<object></object>');
            view.append(angular.element(data));
            elem.html('');
            angular.forEach(attr.$attr, function(val, key){
                if(key !== 'jvObjectData'){
                    view.attr(val, attr[key]);
                }
            });

            return function(scope, el, attr){
                attr.$observe('jvObjectData', function(value){
                    if (!value || (value && value.indexOf('fId=&') > -1))
                        {return;}

                    view.attr('data', value);
                    $(view).remove();
                    if(!$(view).parent()[0]){
                        el.append(view);
                    }
                });
            };
        }
    };
}])

.directive('jvGridScroll', ['$timeout', function($timeout){
    return{
        link:{
            post: function postLink(scope, elem, attr){

                var next = elem.find('a.next');
                var prev = elem.find('a.prev');
                var tableWrapper = elem.parent('.'+attr.jvGridScroll);
                var scrollCount = 200;
                var isSwitched = false;

                var scroll = function(){
                    cancel= $timeout(function(){
                        if(isSwitched){
                            scrollCount = 0 - scrollCount;
                            isSwitched = false;
                        }
                        angular.element(tableWrapper).animate({
                            scrollLeft: tableWrapper[0].scrollLeft+scrollCount
                        }, 500, 'linear');
                        cancel = $timeout(scroll, 500);
                    }, 0);
                };

                angular.element(next).on('hover', function(e){
                    if(e.type === 'mouseenter'){
                        if(scrollCount < 0){
                            isSwitched = true;
                        }
                        scroll();
                    }else if (e.type === 'mouseleave'){
                        angular.element(tableWrapper).stop(true);
                        if(cancel){
                            $timeout.cancel(cancel);
                        }
                    }
                });

                angular.element(prev).on('hover', function(e){
                    if(e.type === 'mouseenter'){
                        if(scrollCount > 0){
                            isSwitched = true;
                        }
                        scroll();
                    }else if (e.type === 'mouseleave'){
                        angular.element(tableWrapper).stop(true);
                        if(cancel){
                            $timeout.cancel(cancel);
                        }
                    }
                });
            }
        }
    };
}])

.directive('jvGridView', [function(){
    return{
        link: {
            post: function postLink(scope, elem, attr){
                var tableWrapper = elem.siblings('.'+attr.jvGridView);
                attr.$observe('jvGridView', function(){
                    var list = elem.find('li');
                    var tableWrapper = elem.siblings('.'+attr.jvGridView);
                    var tr = angular.element(tableWrapper).find('tr');
                    var defaultPadding = 10;
                    angular.forEach(list, function(li, liIndex){
                        var list_height = angular.element(li).height();
                        angular.forEach(tr, function(row, rowIndex){
                            if(liIndex === rowIndex){
                                //adding padding to cell first to calculate increased height of row
                                var td = angular.element(row).find('td');
                                angular.forEach(td, function(tData){
                                    angular.element(tData).css('padding', '{0}px {0}px 0px {0}px'.format(defaultPadding));
                                });
                                var row_height = angular.element(row).outerHeight();
                                var maxHeight = (list_height > row_height ? list_height : row_height) + defaultPadding;
                                angular.element(li).css('height', maxHeight+'px');
                                angular.forEach(td, function(tData){
                                    angular.element(tData).css('height', maxHeight+'px');
                                });
                            }
                        });
                    });
                });

                angular.element(tableWrapper).on('scroll', function(e){
                    scope.evaluations.paging = scope.evaluations.paging || {};
                    if(e.target.scrollLeft === 0){
                        scope.evaluations.paging.next = true;
                        scope.evaluations.paging.prev = false;
                    }else if(e.target.scrollLeft === (e.target.scrollWidth - e.target.clientWidth)){
                        scope.evaluations.paging.next = false;
                        scope.evaluations.paging.prev = true;
                    }else{
                        if(!scope.evaluations.paging.next || !scope.evaluations.paging.prev){
                            scope.evaluations.paging.next = true;
                            scope.evaluations.paging.prev= true;
                        }
                    }
                    scope.$apply();
                });
            }

        }
    };
}])

.directive('jvI18n', [function(){
    return function(scope, linkElement, attrs){
        var attributes = scope.$eval(attrs.jvI18nAttrs);

        if(attributes && attributes.tokenChange){
            var token = scope.format(scope.i18n[attrs.jvI18n], attributes.tokenChange);
            linkElement.append(token);
            delete attributes.tokenChange;
        }else{
            linkElement.append(scope.i18n[attrs.jvI18n]);
        }

        for(var i in attributes){
            linkElement.attr(i, scope.i18n[attributes[i]]);
        }
    };
}])

/**
 * jv:helptext directive is used to show help icon and on click of it showing the help text.
 * The expression takes several params just like a normal function, comma-separated
 * NOTE: Make sure you add {CLOSE} to the i18n in-page variables
 *
 * @param body {string}
 * @param [title] {string} Optional title text
 * @param [classes] {string} Optional additional classes to apply to the container
 **/
.directive('jvTooltip', [function() {
    return function(scope, linkElement, attrs) {
        var result = '',
        classes = 'help ui-hide',
        data = scope.$eval( '[' + attrs.jvTooltip + ']' ),
        close = scope.i18n.CLOSE || '';
        if (!data[0]) {
            return;
        }
        if (data[2]) {
            classes += data[2];
        }
        result += '<div class="' + classes + '">';
        if(data[1]) {
            result += '<h4><a title="'+close+'">[x]</a>'+data[1]+'</h4>';
        }
        result += data[0] + '</div>';

        var view = angular.element(result);

        var $tooltip = linkElement.after(view).next();
        linkElement.click(function(e) {
            e.preventDefault();
            $tooltip.removeClass('ui-hide');
            $('div[class^=help]').not($tooltip).addClass('ui-hide');
        });
        $tooltip.find('h4 a').click(function(e) {
            e.preventDefault();
            $tooltip.addClass('ui-hide');
        });
    };
}])

.directive('jvDynamicTooltip', [function() {
    return function(scope, linkElement, attrs) {
        attrs.$observe('jvTooltipText', function(val){
            if(val){
                var view = createView(val);
                triggerEvents(view);
            }
        });

        var view = createView();
        triggerEvents(view);

        function createView(val){
            var result = '',
            classes = 'help ui-hide',
            data = scope.$eval( '[' + attrs.jvDynamicTooltip + ']' ),
            close = scope.i18n.CLOSE || '';
            if (!data[0]) {
                return;
            }
            if (data[2]) {
                classes += data[2];
            }
            result += '<div class="' + classes + '">';
            if(data[1]) {
                result += '<h4><a title="'+close+'">[x]</a>'+(data[1] || val)+'</h4>';
            }
            result += data[0] + '</div>';

            var view = angular.element(result);
            return view;
        }

        function triggerEvents(view){
            var $tooltip = linkElement.after(view).next();
            linkElement.click(function(e) {
                e.preventDefault();
                $tooltip.removeClass('ui-hide');
                $('div[class^=help]').not($tooltip).addClass('ui-hide');
            });
            $tooltip.find('h4 a').click(function(e) {
                e.preventDefault();
                $tooltip.addClass('ui-hide');
            });

        }
    };
}])

/**
 * jv:preview Used to show a preview window
 * @params window width,height,template,content,scrollbars
 * Positions the new window on the center of the screen
 *
 **/
.directive('jvPreview', [function() {
    return function(scope, elm, attrs) {
        var onClickPreview = function() {
            var params = scope.$eval(attrs.jvPreview);
            var content = params.content;
            var w = params.w;
            var h = params.h;
            var template = params.template;
            var x = screen.width/2 - (w/2);
            var y = screen.height/2 - (h/2);
            var previewWindow = window.open(template,'previewWindow','width='+w+',height='+h+',left='+x+',top='+y+',scrollbars='+params.scrollbar+'');
            previewWindow.document.write('<div style="padding:50px 100px">'+content+'</div>');
            previewWindow.document.body.style.overflow = "auto";
            previewWindow.document.body.style.height = "100%";
            previewWindow.document.getElementsByTagName('html')[0].style.overflow = "hidden";
            previewWindow.focus();
        };
        if (parseFloat(jQuery.fn.jquery) > 1.3) {
            elm.on('click', onClickPreview);
        } else {
            elm.bind('click', onClickPreview);
        }
    };
}])


/**
 * Directive to handle keyboard enter.
 */
.directive('ngEnter', [function () {
    return function (scope, element, attrs) {
        var applyValue = function(event){
            if(event.which === 13) {
                scope.$apply(function (){
                    scope.$eval(attrs.ngEnter);
                });
                event.preventDefault();
            }
        };
        if (parseFloat(jQuery.fn.jquery) > 1.3) {
            element.on('keydown keypress', applyValue);
        } else {
            element.bind('keydown keypress', applyValue);
        }
    };
}])

/**
 * Convenience wrapper for ng-class="someExpression&&'active'"
 */
.directive('jvActive', [function() {
    return function(scope, elm, attrs) {
        scope.$watch(attrs.jvActive, function(newVal, oldVal) {
            if (newVal) {
                elm.addClass('active');
            } else {
                elm.removeClass('active');
            }
        });
    };
}])
.directive('jvScrollto', [function(){
    return function(scope, elm, attrs) {
        elm.on('click', function(){
            var top = $(attrs.jvScrollto).offset().scrollTop || $(attrs.jvScrollto).offset().top;
            $('html,body').animate({ scrollTop: top }, 400);

        });
    };
}])

/*
 * This Directive Is Written To Scroll Down To Incomplete Fields In The Requisition Edit Page.
 * JVScrollTo Fails on Mozilla in this case because processing of the scroll is done before .incomplete class is added to the DOM
 *
 * Use This Without Passing Any Attributes Ex: jv-show-incomplete
 */

.directive('jvShowIncomplete', [function(){
    return function(scope, elm, attrs) {
        elm.on('click', function(){
            var top;
            // Hack For Mozilla
            var incompleteElements = $('.ng-invalid-required:not(form):not(div)').filter(function() {
                var element1 = $(this).parent().parent().parent(); // Get The Parent  Container
                if(element1.css('display') != 'none') {
                    return $(this);
                }
            }).parent();

            var incompleteFieldArray = ($('.ng-invalid-required:not(form):not(div)'));
            scope.incompleteRequired = {};
            angular.forEach(incompleteFieldArray, function(element, key) {
                /**In case of select 2 elements the id needs to be extracted from the sibling select element
                 * The div with class select2-container has no id
                 **/
                var id;
                if(element.type == 'checkbox'){
                    var elemId  = ($(element).attr('id'));
                    var fieldEId = elemId.split('field')[1];
                    if(scope.CheckBox[fieldEId].hasValues){
                        incompleteElements[key] = '';
                    }
                }

                angular.forEach(incompleteElements,function(v,k){

                });

                if($(element).attr('class').split('select2-container')[1]){
                    id = $(element).siblings('select').attr('id');
                }else{
                    id = $(element).attr('id');
                }
                if(id){
                    id = id.split('field')[1];
                    scope.$apply(function(){
                        scope.incompleteRequired[id] = 0;
                    });
                }
            });
            if(incompleteElements.offset()) {
                top = incompleteElements.offset().top;
                $('html,body').animate({ scrollTop: top }, 200);
            }else{
                scope.$emit('allRequiredFieldsFilled',true);
            }
        });
    };
}])

/**
 * Binds a FileUploader widget to an HTML element.
 * uploaderLarge: Added another attribute support (jv-uploader-large) for the new larger version of file uploader.
 * Example:
 * <span ng-model="company.facebookLogoImageURLEdit" jv-uploader-large jv-uploader="{multipleUpload:false,url:'/admin/action/admin/company/profileLogo?imageType=Company',allowedFileTypes:['jpg','png','gif'], isMultipart:true, postParams:{subsidiaryEId:company.eid || '', isFBLogo: true}}">
   </span>
 *
 *
 */
.directive('jvUploader', ['$parse', '$window','$timeout', function($parse, $window, $timeout){
    return function(scope, elm, attrs) {
        var expression = (attrs.jvUploader);
        var params = scope.$eval(expression);
        var fileUploaded = false;
        var uploadResponse;
        var clickedElem = elm[0];
        var classNameHide = '';
        var uploaderLarge = false;
        var imgUrl = null;
        var imgName = null;
        if(attrs.jvUploaderLarge === '') {
        	uploaderLarge = true;
        	$(clickedElem).addClass('uploaderLarge');
        	if(params.imgUrl) {
        		imgUrl = params.imgUrl;
        	}
        	if(params.imgName) {
        		imgName = params.imgName;
        	}
        }
        if(params.classIndex !== undefined) {
            classNameHide = '.' + params.classIndex + '-uploader-error';
        }else {
            classNameHide = '.uploader-error';
        }
        $(classNameHide).hide();

        $(clickedElem).show();
        if(!params.allowedFileTypes){
            params.allowedFileTypes  = [];
        }

        var url = params.url+'&getDownloadToken=true';
        var ngModel = $parse(attrs.ngModel);
        var field = params.field;
        var multipleUpload = params.multipleUpload;

        /*Removing the drop file text in case browser is IE. Not sure if there is a better way to do this NV*/
        if(scope.isIE()){
            scope.i18n['DROP_FILE'] = '';
        }

        ngModel.assign(scope, {});
        //Watching the toggle param to remove the error messages and any files that were uploaded.This is used to reset the uploader widget.
        //This is for cases when the fileuploader is inside a modal or a flyout and you want to reset the fileuploader meaning remove an validation error messages
        // or files that were uploader when the modal/ flyout is closed.The resetUploader is the variable that toggles the show/hide for the modal/flyout --NV
        scope.$watch(params.resetUploader,function(newVal, oldVal){
            if(!newVal){
                $('ul.qq-upload-list').find('li').remove();
                $('.uploader-error').text('');
                if(imgUrl) {
                    $(clickedElem).children('.qq-uploader').children('.qq-upload-button').hide();
                    $(clickedElem).children('.qq-uploader').children('.qq-upload-list').append('<a class="icon dark icon-cross upload-file-delete actn-delete">&nbsp;</a>');

                    $(clickedElem).children('.qq-uploader').children('.qq-upload-list').on('click', '.actn-delete', function(event){
                        var elem = $(event.target).parent('.qq-upload-list').parent('.qq-uploader').parent('.uploaderLarge');
                        $(elem).children('.qq-uploader').children('.qq-upload-drop-area').children().show();
                        $(elem).children('.qq-uploader').children('.qq-upload-drop-area').children('img').remove();
                        $(elem).children('.qq-uploader').children('.qq-upload-drop-area').children('span').text(i18n.DRAG_DROP_IMG_FILE);
                        $(elem).children('.qq-uploader').children('.qq-upload-drop-area').prepend('<i class="icon icon-upload-top dark-sec" style="font-size: 3.5em;"></i>');
                        $(elem).children('.qq-uploader').children('.qq-upload-drop-area').children('span').addClass('dark-sec');

                        // turning off the event before removing it.
                        $(clickedElem).children('.qq-uploader').children('.qq-upload-list').off('click', '.actn-delete', function(event){
                        });
                        $(clickedElem).children('.qq-uploader').children('.qq-upload-list').children('.actn-delete').remove();

                        $(elem).children('.qq-uploader').children('.qq-upload-button').show();
                        ngModel.assign(scope, 'Delete');
                    });
                }
                initUploader(clickedElem);
                var uploaderButton =  $(clickedElem).children('.qq-uploader').children('.qq-upload-button').children('input[type="file"]');
                uploaderButton.prop('disabled',false);
            }
        },true);

        var floorFigure = function(figure, decimals){
            if (!decimals) {decimals = 2;}
            var d = Math.pow(10,decimals);
            return ((figure*d)/d).toFixed(decimals);
        };
        var renderTotal = function(){
            if(!scope.totalRendered){
                scope.uploadLimitReached = false;
                var totalUploaded  = ((scope.fileUploadMap.total/scope.uploadLimit)*10);
                totalUploaded = floorFigure(totalUploaded,1);
                $(clickedElem).siblings('.uploader-error').hide();
                $(clickedElem).siblings('.uploader-error').text('');
                $(clickedElem).children('.qq-uploader').children('.qq-upload-instruction').children('.total-uploaded').remove();
                $(clickedElem).children('.qq-uploader').children('.qq-upload-instruction').append('<span class="total-uploaded"> '+i18n.TOTAL+': '+totalUploaded+'MB</span>');
                scope.totalRendered = true;
            }
        };
        //removing total count
        var initUploader = function(clickedElem){
            scope.uploadLimit = params.sizeLimit || 10485760;
            scope.contentUploaded = 0;
            //used to store data about each file
            scope.fileUploadMap = {
                total: 0
            };
            scope.uploadLimitReached = false;
            if(uploaderLarge) {
            	$(clickedElem).children('.qq-uploader').children('.qq-upload-instruction').remove();
            	if(imgUrl) {
            		$(clickedElem).children('.qq-uploader').children('.qq-upload-drop-area').children().hide();
                	$(clickedElem).children('.qq-uploader').children('.qq-upload-drop-area').append('<img src='+imgUrl+'>');
                	if(imgName) {
                		$(clickedElem).children('.qq-uploader').children('.qq-upload-drop-area').append('<div class="qq-uploader-img">"+imgName+"</div>');
                    }
                    $(clickedElem).children('.qq-uploader').children('.qq-upload-button').hide();
                    $(clickedElem).children('.qq-uploader').children('.qq-upload-drop-area').children('span').addClass('.actn-delete');
                    $(clickedElem).children('.qq-uploader').children('.qq-upload-drop-area').children('span').children('.actn-delete').removeClass('icon-delete').addClass('icon-cross');
            	} else {
            		$(clickedElem).children('.qq-uploader').children('.qq-upload-drop-area').prepend('<i class="icon icon-upload-top dark-sec" style="font-size: 3.5em;"></i>');
                	$(clickedElem).children('.qq-uploader').children('.qq-upload-drop-area').children('span').text(i18n.DRAG_DROP_IMG_FILE);
                	$(clickedElem).children('.qq-uploader').children('.qq-upload-drop-area').children('span').addClass('dark-sec');
            	}
            } else {
            	$('.qq-upload-instruction').children('.total-uploaded').remove();
            }
        };

        var cancelFileUpload = function(id,loaded,fileName){
            scope.fileUploadMap.total -= scope.fileUploadMap[id];
            scope.uploadLimitReached  = true;
            scope.contentUploaded  = loaded;
            delete scope.fileUploadMap[id];
            var errorMsg = fileName+' is too large, maximum file size is 10MB.';
            uploader._options.showMessage(errorMsg);
            //cancel the upload
            uploader._handler.cancel(id);
            //remove the file from the DOM
            $('.qq-upload-list li:last-child').remove();
            scope.totalRendered = true;
            return false;
        };

        var updateTotal = function(id,loaded){
            scope.contentUploaded = loaded;
            scope.fileUploadMap[id] = loaded;
            scope.fileUploadMap.total += scope.contentUploaded;
        };

        var uploader = new qq.FileUploader({
            element: clickedElem,
            action: url,
            allowedExtensions: params.allowedFileTypes ,
            sizeLimit:params.sizeLimit || 10485760,
            multiple: false,
            removeFileTypeText: params.removeFileTypeText,
            uploadButtonText: params.uploadButtonText,
            fileTypeHelpText: params.fileTypeHelpText,
            crossIcon: params.crossIcon,
            i18n:i18n,
            debug:false,
            customHeaders: angular.fromJson(params.customHeaders),
            forceMultipart: params.isMultipart || false,
            params: angular.fromJson(params.postParams),
            onSubmit: function(id, fileName){
                /* When multiple is set to false (only one file can be uploaded),
                 * Initialize the scope.fileName to false.
                 * Use case: When a file is uploaded but the page is not refreshed,
                 * scope.fileName stores the value of the file that was uploaded previously.
                 * And the new name of the file (fileName from the parameter) would be used.
                 * Fixed for: https://jobvite.atlassian.net/browse/US-1028
                 */
                if(!params.multipleUpload){
                    scope.fileName = false;
                }
                //block multiple file uploads when multiple is set to false
                if(!params.multipleUpload && scope.fileName){
                    var multipleFileUploadError = i18n.MULTIPLE_FILE_UPLOAD_ERROR || 'Please remove existing file before uploading a new one';
                    uploader._options.showMessage(multipleFileUploadError);
                    return false;
                }
                //support for blacklisted file types
                scope.$apply(function(){
                    scope.fileName = fileName;
                });
                if(!scope.contentUploaded){
                    initUploader();
                }
                if(scope.uploadLimitReached){
                    scope.uploadLimitReached = false;
                }
                if(params.disAllowedFileTypes){
                    for (var i = 0 ; i < params.disAllowedFileTypes.length ; i++) {
                        var fileType = params.disAllowedFileTypes[i];
                        var re = new RegExp( fileType,'gi');
                        var file_name_array = fileName.split('.');
                        var file_extension = file_name_array[file_name_array.length - 1];
                        var found = file_extension.match(re);
                        if(found instanceof Array){
                            uploader._options.showMessage(i18n.INVALID_FILE_TYPE);
                            return false;
                        }
                    }
                }
                //sending a flag to the UI
                scope.$emit('fileUploadComplete',false);
                $('.text_fallback').remove();
                if($('.uploader-error').length!==0){
                    var className = '';
                    if(params.classIndex !== undefined) {
                        className = '.' + params.classIndex + '-uploader-error';
                    }else {
                        className = '.uploader-error';
                    }
                    $(className).hide();
                    //$('.uploader-error').hide();
                }

                if(navigator.userAgent.match(/msie/i)){
                    $(clickedElem).append('<span class="ie_loader"> </span>');
                    $(clickedElem).append('<strong class="text_fallback"> </strong>');
                }else{
                    $(clickedElem).append('<progress max="100"></progress>');
                }
                fileUploaded = false;
                $('.cancel-upload').on('click',function(){
                    uploader._handler.cancel(id);
                    $('.qq-upload-list > li:last-child').remove();
                    $(clickedElem).children('progress').remove();
                    //$(clickedElem).children('.cancel-upload').remove();
                    $(clickedElem).children('.qq-uploader').fadeIn(200);
                    return false;
                });
            },
            onDelete : function (id,fileName,EId){
                scope.fileUploadMap.total -= scope.fileUploadMap[id];
                delete scope.fileUploadMap[id];
                if(scope.fileUploadMap.total === 0){
                    initUploader();
                }else{
                    scope.totalRendered = false;
                    renderTotal();
                }

                //showing the upload button again
                $(clickedElem).children('.text_fallback').remove();
                //remove upload-error
                $(clickedElem).siblings('.uploader-error').hide();

                if(!multipleUpload && ($('.qq-upload-button,.qq-upload-instruction').length!=0)) {
                    $(clickedElem).children('.qq-uploader').children('.qq-upload-button').fadeIn(200);
                    $(clickedElem).children('.qq-uploader').children('.qq-upload-instruction').fadeIn(200);
                }

                if(uploadResponse && uploadResponse.msgInfo === 200 && fileUploaded){
                    $(clickedElem).children('progress').hide();
                } else if (uploadResponse && uploadResponse.result && uploadResponse.result.logoImageURL && attrs.jvUploaderLarge === ''){
                    $(clickedElem).children('.qq-uploader').children('.qq-upload-drop-area').children('img').remove();
                    if(fileName) {
                        $(clickedElem).children('.qq-uploader').children('.qq-upload-drop-area').children('.qq-uploader-img').remove();
                    }
                    $(clickedElem).children('.qq-uploader').children('.qq-upload-drop-area').prepend('<i class="icon icon-upload-top dark-sec" style="font-size: 3.5em;"></i>');
                	$(clickedElem).children('.qq-uploader').children('.qq-upload-drop-area').children('span').text(i18n.DRAG_DROP_IMG_FILE).show();
                	$(clickedElem).children('.qq-uploader').children('.qq-upload-drop-area').children('span').addClass('dark-sec');
                } else {
                    scope.$apply(function(){
                        //This is another hack around ./../TalentNetwork/action/common/fileupload?action=uploadTemp. Since this end point does not return any response. Just making resourceInfo
                        //object null wont work . We have to manually set the GUID and fileName as null.
                        scope.GUID = false;
                        scope.fileName = false;
                        angular.forEach(ngModel(scope), function(src, key) {
                            //TODO: Remove employee sync file specific use case
                            if(key === 'employeeSyncKey') {
                                var model = scope.$eval(attrs.ngModel);
                                // emitting 'ImportFileUploadComplete' event to let module knows if the file deleted
                                scope.$emit('ImportFileUploadComplete', false);
                                delete model[key];
                            }

                            if(src.resourceInfo && src.resourceInfo.eid === EId){
                                if(key=='null'){
                                    ngModel.assign(scope.$parent, {});
                                }
                                var model = scope.$eval(attrs.ngModel);
                                delete model[key];
                            }
                        });
                    });
                    return false;
                }
            },
            onProgress : function(id, fileName, loaded, total){
               var uploaderButton =  $(clickedElem).children('.qq-uploader').children('.qq-upload-button').children('input[type="file"]');
               uploaderButton.prop('disabled',true);
                //in IE the onProgress method never gets fired
                if(!fileUploaded){
                    scope.totalRendered = false;
                    if(loaded === total && !scope.uploadLimitReached){
                            updateTotal(id,loaded);
                            if( scope.fileUploadMap.total > scope.uploadLimit  ){
                                cancelFileUpload(id,loaded,fileName);
                            }
                            renderTotal();
                    }
                    var percent = (loaded/total)*100;
                    percent = Math.round(percent);
                    if(percent == 100){
                        fileUploaded = true;
                        // emitting 'ImportFileUploadComplete' event to let module knows if the file uploaded
                        scope.$emit('ImportFileUploadComplete', true);
                    }
                    if(!scope.totalRendered && fileUploaded){
                        //For cases when after file upload is done the total is != loaded hence adding this block to check the difference.
                        var diff = total-loaded;
                        if( diff <= 100000 && !scope.uploadLimitReached){
                            updateTotal(id,loaded);
                            if( scope.fileUploadMap.total > scope.uploadLimit  ){
                                cancelFileUpload(id,loaded,fileName);
                            }
                            renderTotal();
                        }
                    }
                    $('.icon .icon-delete .upload-file-delete').hide();
                    if (parseFloat(jQuery.fn.jquery) >= 1.7) {
                        $(clickedElem).children('progress').val(percent);
                    } else {
                        $(clickedElem).children('progress').attr('value',percent);
                    }

                    //In older browsers that dont support the progress bar tag this text will show up

                }else{
                    if (parseFloat(jQuery.fn.jquery) >= 1.7) {
                        $(clickedElem).children('progress').val(100);
                    } else {
                        $(clickedElem).children('progress').attr('value',100);
                    }
                    $(clickedElem).children('progress').remove();
                    $(clickedElem).children('.qq-uploader').fadeIn(200);
                    $('.icon .icon-delete .upload-file-delete').show();
                }
            },
            onCancel: function (id,filename){
                $(clickedElem).children('progress').remove();
                $(clickedElem).children('.ie_loader').remove();
                setTimeout(function(){
                    var uploaderButton =  $(clickedElem).children('.qq-uploader').children('.qq-upload-button').children('input[type="file"]');
                    uploaderButton.prop('disabled',false);
                },300);
                $(clickedElem).children('.qq-uploader').fadeIn(200);
                $('.icon .icon-delete .upload-file-delete').show();
            },
            onComplete: function(id, fileName, responseJSON){
                //HIRE-6425: Adding an escape function here. Needs to be done at backend primarily.
                var escapeHtml =  function(unsafe) {
                    return unsafe
                         .replace(/&/g, '&amp;')
                         .replace(/</g, '&lt;')
                         .replace(/>/g, '&gt;')
                         .replace(/"/g, '&quot;')
                         .replace(/'/g, '&#039;');
                 };

                var uploaderButton =  $(clickedElem).children('.qq-uploader').children('.qq-upload-button').children('input[type="file"]');
                function loadResponse(responseJSON, fileName) {
                    //TODO: Remove employee sync file specific use case
                    if (responseJSON && responseJSON.employeeSyncKey) {
                        responseJSON.fileName = fileName;
                        return responseJSON;
                    }
                    var temporaryObject = {};
                    if(responseJSON && responseJSON.fileName){
                        temporaryObject.file = responseJSON.fileName;
                        temporaryObject.hasFileChanged = responseJSON.hasFileChanged;
                        return temporaryObject;
                    }
                    if(responseJSON && responseJSON.resourceInfo) {
                        responseJSON.resourceInfo.fileName = escapeHtml(fileName);
                        temporaryObject[responseJSON.resourceInfo.eid] = responseJSON;
                    }else if(responseJSON && responseJSON.picInfo){
                        responseJSON.resourceInfo = {
                            fileName : responseJSON.picInfo.fileName,
                            uploaded : responseJSON.picInfo.uploaded
                        };
                        temporaryObject['picInfo'] = responseJSON.resourceInfo;
                    } else if(responseJSON && uploadResponse.result && uploadResponse.result.logoImageURL && attrs.jvUploaderLarge === '') {
                    	//uploaderLarge
                    	$(clickedElem).children('.qq-uploader').children('.qq-upload-drop-area').children().hide();
                    	$(clickedElem).children('.qq-uploader').children('.qq-upload-drop-area').append('<img src='+responseJSON.result.logoImageURL+'>');
                    	if(fileName) {
                    		$(clickedElem).children('.qq-uploader').children('.qq-upload-drop-area').append('<div class="qq-uploader-img">'+fileName+'</div>');
                        }
                        if($(clickedElem).children('.qq-uploader').children('.qq-upload-list').children('.qq-upload-success').children('.actn-delete').hasClass('icon-delete')){
                            $(clickedElem).children('.qq-uploader').children('.qq-upload-button').hide();
                            $(clickedElem).children('.qq-uploader').children('.qq-upload-list').children('.qq-upload-success').children('.actn-delete').removeClass('icon-delete').addClass('icon-cross');
                        }
                    	temporaryObject = responseJSON.result.logoImageURL;
                    }else if(responseJSON && responseJSON.result && attrs.jvUploaderLarge === ''){
                        $(clickedElem).children('.qq-uploader').children('.qq-upload-list').children().hide();
                        $(clickedElem).children('.qq-uploader').children('.qq-upload-drop-area').children().hide();
                        $(clickedElem).children('.qq-uploader').children('.qq-upload-drop-area').prepend('<div class="jv-error-container">');

                        if(responseJSON.result.errorMessageInvalidFile){
                            $(clickedElem).children('.qq-uploader').children('.qq-upload-drop-area').children('.jv-error-container').append('<i class="icon icon-warning large " >'+ responseJSON.result.errorMessageInvalidFile+'</i>');
                        }else{
                            for(var errorMessage in responseJSON.result){
                                $(clickedElem).children('.qq-uploader').children('.qq-upload-drop-area').children('.jv-error-container').append('<i class="icon icon-warning large " >'+responseJSON.result[errorMessage]+'</i>');
                            }
                        }
                        $(clickedElem).children('.qq-uploader').children('.qq-upload-drop-area').append('</div>');
                    }
                    return temporaryObject;
                }
                if(navigator.userAgent.match(/msie/i)){

                    scope.$apply(function(){

                        var tmp = loadResponse(responseJSON, fileName);
                        if(field){
                            responseJSON.field = field;
                        }
                        if(attrs.ngModel=='coverletteruploader'||attrs.ngModel=='resumeuploader' || !multipleUpload){
                        	if(attrs.jvUploaderLarge !== '') {
                        		$(clickedElem).children('.qq-uploader').children('.qq-upload-button').hide(200);
                            }
                            $(clickedElem).children('.qq-uploader').children('.qq-upload-instruction').hide(200);
                        } else {
                            angular.extend(tmp, ngModel(scope));
                        }
                        ngModel.assign(scope, tmp);
                    });
                    fileUploaded = false;
                    $(clickedElem).children('progress').remove();
                    $(clickedElem).children('.ie_loader').remove();
                    $(clickedElem).children('.text_fallback').text('100%');
                    $('.icon .icon-delete .upload-file-delete').show();
                    uploadResponse.msgInfo = '';
                    uploaderButton.prop('disabled',false);

                }
                uploadResponse = responseJSON;
                var index = this._handler._xhrs.length-1;
                if( (responseJSON.msgInfo == 200|| this._handler._xhrs[index].status == 200) && fileUploaded){
                    uploaderButton.prop('disabled',false);
                    var tmp = loadResponse(responseJSON, fileName);
                    if(field){
                        responseJSON.field = field;
                    }
                    if(attrs.ngModel=='coverletteruploader'||attrs.ngModel=='resumeuploader' || !multipleUpload){
                        //single file upload case
                    	if(attrs.jvUploaderLarge !== '') {
                    		$(clickedElem).children('.qq-uploader').children('.qq-upload-button').hide(200);
                        }
                        $(clickedElem).children('.qq-uploader').children('.qq-upload-instruction').hide(200);
                    }else{
                        angular.extend(tmp, ngModel(scope));
                    }
                    ngModel.assign(scope, tmp);

                    fileUploaded = false;
                    $(clickedElem).children('progress').remove();
                    /*This is for users to be able to download the recently uploaded file*/
                    var lastAddedFile = ($(clickedElem).children('.qq-uploader').find('.qq-upload-success:last').children('.qq-upload-file'));
                    if(params.downloadURL) {
                        $(lastAddedFile).html('<a href="{0}">{1}</a>'.format(params.downloadURL.format(responseJSON.resourceInfo.eid,responseJSON.fileDownloadToken), responseJSON.resourceInfo.fileName));
                    } else{
                        $(lastAddedFile).html('<a href="' + $window.jvUrls.jhire + '/action/resource/attachment/'+responseJSON.resourceInfo.eid+'?fileDownloadToken='+responseJSON.fileDownloadToken+'&fId='+responseJSON.resourceInfo.eid+'">'+responseJSON.resourceInfo.fileName+'</a>');
                    }
                    $('.icon .icon-delete .upload-file-delete').show();
                    uploadResponse.msgInfo = '';
                    scope.$apply();
                }else if(responseJSON.msgInfo == 400 && responseJSON.msgError){
                    $(clickedElem).find('.qq-upload-list').empty();
                    uploaderButton.prop('disabled',false);
                    uploader._options.showMessage(responseJSON.msgError);
                }else if(responseJSON.msgInfo == 401){
                    $(clickedElem).find('.qq-upload-list li:last-child .qq-upload-failed-text').html(i18n.FILE_FORMAT_IS_NOT_SUPPORTED);
                }else if(responseJSON.msgInfo == 417){
                    var illegalContentError = i18n.I18N_MALICIOUS_CONTENT || 'This file is not permitted to upload for security reasons. Please check your file for any malicious content or link.';
                    $(clickedElem).find('.qq-upload-list').empty();
                    $(clickedElem).children('.qq-uploader').children('.qq-upload-instruction').children('.total-uploaded').remove();
                    uploaderButton.prop('disabled',false);
                    uploader._options.showMessage(illegalContentError);
                }
                //sending a flag to the UI
                scope.$emit('fileUploadComplete',true);

            },
            showMessage: function(message){
                if(message){
                    var className = '';
                    if(params.classIndex !== undefined) {
                        className = '.' + params.classIndex + '-uploader-error';
                    }else {
                        className = '.uploader-error';
                    }
                    $(clickedElem).siblings(className).text(message).show();
                }
            }
        });
        scope.$emit('uploaderDirectiveLoaded',true);

    };
}])

/**
 *Binds a FileUploader widget to an HTML element.
 */
.directive('jvUploaderReBinder', ['$parse', function($parse){
    return function(scope, elm, attrs) {
        var expression = (attrs.jvUploaderReBinder);
        var params = scope.$eval(expression);
        //scope.$parent.$root.file.showUploadPanel = true;
        var fileUploaded = false;
        var uploadResponse;
        var clickedElem = elm[0];
        //$('.uploader-error').hide();

        var classNameHide = '';
        if(params.classIndex !== undefined) {
            classNameHide = '.' + params.classIndex + '-uploader-error';
        }else {
            classNameHide = '.uploader-error';
        }
        $(classNameHide).hide();


        $(clickedElem).show();
        if(!params.allowedFileTypes){
            params.allowedFileTypes  = [];
        }

        //This is to flush out the fid incase you upload a resume and hit cancel and come over to attachments and upload a new attachment.
        //scope.$parent.$root.resourceInfo.fId = [];
        var url = params.url;
        var ngModel = $parse(attrs.ngModel);
        var field = params.field;
        var multipleUpload = params.multipleUpload;
        ngModel.assign(scope, {});
        var uploader = new qq.FileUploader({
            element: clickedElem,
            action: url,
            allowedExtensions: params.allowedFileTypes ,
            sizeLimit:10485760,
            multiple: true,
            removeFileTypeText: params.removeFileTypeText,
            uploadButtonText: params.uploadButtonText,
            fileTypeHelpText: params.fileTypeHelpText,
            i18n:i18n,
            debug:false,
            onSubmit: function(id, fileName){
                //support for blacklisted file types
                if(params.disAllowedFileTypes){
                    for (var i = 0 ; i < params.disAllowedFileTypes.length ; i++) {
                        var fileType = params.disAllowedFileTypes[i];
                        var re = new RegExp( fileType,'gi');
                        var found = fileName.match(re);
                        if(found instanceof Array){
                            uploader._options.showMessage('Invalid File Type');
                            return false;
                        }
                    }
                }
                //sending a flag to the UI
                scope.$emit('fileUploadComplete',false);
                if($('.uploader-error').length!==0){
                    var className = '';
                    if(params.classIndex !== undefined) {
                        className = '.' + params.classIndex + '-uploader-error';
                    }else {
                        className = '.uploader-error';
                    }
                    $(className).hide();
                    //$('.uploader-error').hide();
                }
                $(clickedElem).append('<progress max="100"><strong class="text_fallback"> </strong></progress>');
                fileUploaded = false;
                $('.cancel-upload').on('click',function(){
                    uploader._handler.cancel(id);
                    $('.qq-upload-list > li:last-child').remove();
                    $(clickedElem).children('progress').remove();
                    //$(clickedElem).children('.cancel-upload').remove();
                    $(clickedElem).children('.qq-uploader').fadeIn(200);
                    return false;
                });
            },
            onDelete : function (id,fileName){
                //showing the upload button again
                if(!multipleUpload && ($('.qq-upload-button,.qq-upload-instruction').length!=0)) {
                    $(clickedElem).children('.qq-uploader').children('.qq-upload-button').fadeIn(200);
                    $(clickedElem).children('.qq-uploader').children('.qq-upload-instruction').fadeIn(200);
                }

                if(uploadResponse && uploadResponse.msgInfo == 200 && fileUploaded){
                    $(clickedElem).children('progress').hide();
                }else{
                    scope.$apply(function(){
                        angular.forEach(ngModel(scope), function(src, key) {
                            if(src.resourceInfo.fileName == fileName){
                                if(key=='null'){
                                    ngModel.assign(scope.$parent, {});
                                }
                                var model = scope.$eval(attrs.ngModel);
                                delete model[key];
                            }
                        });
                    });
                    return false;
                }
            },
            onProgress : function(id, fileName, loaded, total){
                if(!fileUploaded){
                    var percent = (loaded/total)*100;
                    percent = Math.round(percent);
                    if(percent == 100){
                        fileUploaded = true;
                    }
                    $('.icon .icon-delete .upload-file-delete').hide();
                    if (parseFloat(jQuery.fn.jquery) >= 1.7) {
                        $(clickedElem).children('progress').val(percent);
                    } else {
                        $(clickedElem).children('progress').attr('value',percent);
                    }
                    //In older browsers that dont support the progress bar tag this text will show up
                    $(clickedElem).children('.text_fallback').text(percent+'%');
                }else{

                    if (parseFloat(jQuery.fn.jquery) >= 1.7) {
                        $(clickedElem).children('progress').val(100);
                    } else {
                        $(clickedElem).children('progress').attr('value',100);
                    }
                    $(clickedElem).children('progress').remove();
                    $(clickedElem).children('.qq-uploader').fadeIn(200);
                    $('.icon .icon-delete .upload-file-delete').show();
                    uploadResponse.msgInfo = '';
                }
            },
            onCancel: function (id,filename){
                $(clickedElem).children('progress').remove();
                $(clickedElem).children('.qq-uploader').fadeIn(200);
                $('.icon .icon-delete .upload-file-delete').show();
            },
            onComplete: function(id, fileName, responseJSON){
                if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.userAgent.indexOf('Trident/') > 0) {
                    scope.$apply(function(){
                        var tmp = {};
                        if(field){
                            responseJSON.field = field;
                        }
                        tmp[responseJSON.resourceInfo.eid] = responseJSON;
                        ngModel.assign(scope, tmp);
                    });
                    fileUploaded = false;
                    $(clickedElem).children('.qq-uploader-file').remove();
                    $(clickedElem).children('progress').remove();
                    uploadResponse.msgInfo = '';

                }
                uploadResponse = responseJSON;
                if(responseJSON.msgInfo == 200 && fileUploaded){
                    var tmp = {};
                    if(field){
                        responseJSON.field = field;
                    }
                    tmp[responseJSON.resourceInfo.eid] = responseJSON;
                    ngModel.assign(scope, tmp);

                    fileUploaded = false;
                    $(clickedElem).children('.qq-uploader-file').remove();
                    $(clickedElem).children('progress').remove();
                    $('.icon .icon-delete .upload-file-delete').show();
                    uploadResponse.msgInfo = '';
                    scope.$apply();
                }else if(responseJSON.msgInfo == 401){
                    $(clickedElem).find('.qq-upload-list li:last-child .qq-upload-failed-text').html('This file format is not supported');
                }
                //sending a flag to the UI
                scope.$emit('fileUploadComplete',true);

            },
            showMessage: function(message){
                if(message){
                    var className = '';
                    if(params.classIndex !== undefined) {
                        className = '.' + params.classIndex + '-uploader-error';
                    }else {
                        className = '.uploader-error';
                    }
                    $(clickedElem).siblings(className).text(message).show();
                }
            }
        });
        scope.$emit('uploaderDirectiveLoaded',true);
    };
}])
/**
 * Binds a TinyMCE widget to <textarea> elements.
 */
.directive('jvWysiwyg', [function(){
    return function(scope, elm, attrs) {
        var options = {
                theme: 'advanced',
                button_title_map: false,
                apply_source_formatting: true,
                plugins: 'table,contextmenu,advimage,advlink,paste,fullscreen',
                theme_advanced_toolbar_align: 'left',
                theme_advanced_buttons1: 'formatselect,seperator,undo,redo,seperator,justifyleft,justifycenter,justifyright,separator,bold,italic,underline,separator,bullist,numlist,link,separator,imagepopup,table,separator,sub,sup,separator,code',
                theme_advanced_buttons2: '',
                theme_advanced_buttons3: '',
                theme_advanced_toolbar_location: 'top',
                theme_advanced_path_location : 'bottom',
                theme_advanced_resizing : true,
                theme_advanced_blockformats : 'p,h2,h3,blockquote',
                theme_advanced_resizing_max_width: 520,
                theme_advanced_resizing_min_width: 520,
                // Update Textarea and Trigger change event
                handle_event_callback: function(e) {
                    if (this.isDirty()) {
                        this.save();
                        elm.trigger('change');
                    }
                    return true; // Continue handling
                },
                formats : {
                    underline : { inline : 'u', exact : true }
                }
        };
        //angular.extend(options, expression);
        //elm.tinymce(options);
    };
}])



/**
 * Makes the element jquery ui draggable.
 * TODO: Use the generic(pass-through) jquery ui directive for this.
 *       Pass options using config variable
 *       Write ngdocs
 */

.directive('jvData', [function() {
    return function(scope, elm, attrs) {
        var data =  scope.$eval(attrs.jvData);
        if(data.dynamic){
            scope.$watch(data.dynamic, function(newVal){
                data.value = newVal;
                jqData(data);
            });
        }else{
            jqData(data);
        }


        function jqData(data){
            if(data.hasOwnProperty('elm')) {
                if(data.elm !== 'onlyChildren'){
                    elm.data(data.key?data.key:'jvJqData', data.value?data.value:data);
                }

                if(data.elm == 'allChildren'){
                    elm.find('*').data(data.key?data.key:'jvJqData', data.value?data.value:data);
                }

            }else{
                elm.data(data.key?data.key:'jvJqData', data.value?data.value:data);
            }
        }

    };
}])

/*
 * Synchronizes the model and view values for the timepicker widget. Populate the ng-model with a object whose
 * 'h' property is the number of hours, and 'm' property is minutes in accordance with Javscript Date object.
 * Given an object of the above kind it populates the timepicker with the respective time.
 *
 *  Time format validation for editable timepickers is also included.
 *
 * Required Files:
 * "lib/jquery/timepicker/jquery.timepicker.js"
 */
.directive('jvTimepicker', [function() {
    return {
        require: '?ngModel',
        link: function(scope, elm, attrs, controller) {
            elm.timepicker({timeFormat: 'g:i A', step: 15});
            elm.on('change blur', function(){
                scope.$apply(function(){
                    if(elm.val() || elm[0].defaultValue){
                        var updatedTime = (controller.$viewValue !== elm.val() || (controller.$viewValue === elm.val() && !elm[0].defaultValue)) ? elm.val() : elm[0].defaultValue;
                        controller.$setViewValue(updatedTime);
                        controller.$render();
                    }
                });
            });

            controller.$parsers.unshift(function(viewValue){
                var obj = {}, pm = false, delimIndex, oldViewValue, re = /^(?:0?\d|1[012]):[0-5]\d\s[A|P]M$/;
                if(!angular.isString(viewValue)){
                    return;
                }
                if(!viewValue.match(re)){
                    controller.$setValidity('format', false);
                    return;
                }else{
                    controller.$setValidity('format', true);
                }
                delimIndex = viewValue.indexOf(':');
                obj.h = parseInt(viewValue.substring(0, delimIndex));
                obj.m = parseInt(viewValue.substring(delimIndex+1, delimIndex+3));

                pm = viewValue.substring(viewValue.length-2, viewValue.length).toLowerCase() === 'pm';
                if(pm){
                    if(obj.h != 12){
                        obj.h += 12;
                    }
                }else if(obj.h === 12){
                    obj.h = 0;
                }
                oldViewValue = obj;
                return obj;
            });

            controller.$formatters.push(function(modelValue){
                var hours, mins , res;
                if(!modelValue || typeof modelValue.h === 'undefined' || typeof modelValue.m === 'undefined'){
                    return;
                }
                hours = modelValue.h;
                mins = modelValue.m;
                if(angular.isObject(modelValue)){
                    if(hours === 0){
                        hours = 12;
                    } else if(hours > 12){
                        hours = hours -12;
                    }
                    res = hours + ':' + (modelValue.m<10?'0'+modelValue.m:modelValue.m )+  (modelValue.h>11?' PM':' AM');
                    return res;
                }
            });
        }
    };
}])


.directive('fullcalendar', [function(){
    return {
        link: function($scope, element, attrs){
            var namespace = 'fc';
            var options ={};
            var calendar;
            var config =  $scope.$eval(attrs.fullcalendar);
            var fcCallbacks = ['viewDisplay', 'windowResize', 'dayClick', 'eventClick', 'eventMouseover','eventMouseout',
                               'select', 'loading','eventRender','eventAfterRender','eventDragStart','eventDragStop','eventDrop','eventResizeStart',
                               'eventResizeStop', 'eventResize', 'drop'];

            var fcMethods = ['prev', 'next', 'gotoDate', 'render', 'destroy', 'changeView', 'prevYear', 'nextYear', 'today', 'incrementDate', 'select', 'unselect',
                             'updateEvent', 'removeEvents', 'refetchEvents', 'addEventSource', 'removeEventSource', 'renderEvent', 'rerenderEvents', 'clientEvents', 'getDate'];
            var rendered = false;

            var defaultOptions = {
                    editable:true,
                    events:[]
            };

            // All calendar objects in  $scope.

            $scope.calendars = $scope.calendars || {};

            $scope.addCalendar = function(calendar, namespace){
                namespace = namespace || 'fc';
                $scope.calendars[namespace] = calendar;
            };

            $scope.getCalendar = function(namespace){
                return $scope.calendars[namespace];
            };

            // Preparing defaultoptions to 'broadcast' callbacks

            if(config.namespace){
                namespace = $scope.$eval(config.namespace);
            }

            function createBroadcast(names, factory, context){
                angular.forEach(names, function(name){
                    //console.log("registering..." + namespace+ "." + name);
                    context[name] = factory(name);
                });
            }

            function createCallbackBroadcast(eventName){
                return function(){
                    var args = Array.prototype.slice.call(arguments);
                    args.unshift(namespace+ '.' + eventName);
                    $scope.$broadcast.apply($scope, args);
                };
            }

            function createMethodBroadcast(methodName){
                return function(){
                    var args, returnVal;
                    args = Array.prototype.slice.call(arguments);

                    args.unshift(methodName);
                    returnVal = calendar.fullCalendar.apply(calendar, args);

                    args = args.slice(1);
                    args.unshift(namespace+ '.' + methodName);
                    $scope.$broadcast.apply($scope, args);
                    return returnVal;
                };
            }

            createBroadcast(fcCallbacks, createCallbackBroadcast, defaultOptions);
            if(config.options){
                options = $scope.$eval(config.options);
                angular.extend(defaultOptions, options);
            }

            if(!config.lazyLoad){
                renderCalendar();
            }else{
                $scope.$watch(config.lazyLoad, function(newValue, oldValue){
                    if(calendar && calendar.rendered){
                        return; // todo: unwatch
                    }

                    if(newValue){
                        renderCalendar();
                    }
                });
            }

            function renderCalendar(){
                if(config.options){
                    options = $scope.$eval(config.options);
                    angular.extend(defaultOptions, options);
                }

                if(defaultOptions.defaultView === 'resourceDay' && $.isEmptyObject(defaultOptions.resources)){
                    //console.log('Not rendering the resource view calendar as there are no resources'); // Intentionally not throwing exception
                    return;
                }
                calendar = element.fullCalendar(defaultOptions);
                calendar.rendered = true;
                calendar.options = defaultOptions;
                createBroadcast(fcMethods, createMethodBroadcast, calendar);
                $scope.addCalendar(calendar, namespace);
                $scope.$broadcast(namespace+'.created', calendar);
            }
        }
    };
}])


.directive('schEventrender', ['$filter', '$compile', function($filter, $compile){
    return function($scope, element, attrs){
        $scope.$on($scope.SCHEDULER_NAMESPACE+'.eventRender', function(ngEvent, event, element, view){
            var contentElm = element.find('.fc-event-content '),
            titleElm = element.find('.fc-event-title'),
            renderResources = false,
            index = 0,
            names = [],
            calendar = $scope.getCalendar($scope.SCHEDULER_NAMESPACE),
            intrvr;

            contentElm.html('');
            titleElm.html('');
            contentElm.html(titleElm);

            angular.forEach(event.interviewers, function(interviewer, eid){
                var statusElm;
                if(interviewer){
                    if(!interviewer.hasOwnProperty('ProfilePictureUrl')){
                        intrvr = $scope.interviewers[eid];
                        // ToDo: Check and remove. Hit the userprops cache is appropriate
                        if(intrvr && intrvr.hasOwnProperty('ProfilePictureUrl')){
                            interviewer.ProfilePictureUrl = intrvr.ProfilePictureUrl;
                        }
                    }
                    var name = interviewer.firstName + ' ' + interviewer.lastName;

                    if (interviewer.interviewStatus){
                        statusElm = $('<span />').text(' ('+ interviewer.interviewStatus + ')');
                        if(interviewer.interviewStatus === 'Declined'){
                            statusElm.css('color', '#f40000');
                        }
                        name += statusElm.html();
                    }

//                    titleElm.append('<img src="'+$scope.icon(interviewer)+'"/>');
                    names.push(name);
                }
            });

            contentElm.append(names.join(', '));
            //The dates are already in the users timezone so using date filter
            let time = $filter('date')(event.start, 'shortTime', 'HH:mm');

            if (event.end) {
                time += ' - ' + $filter('date')(event.end, 'shortTime','HH:mm');
            }
            if (event.location) {
                time += ' : ' + $scope.allLocations[event.location].name;
            }
            contentElm.append('<span>'+time+'</span>');

            if(event.currentTimeBar){
                element.addClass('circle now');
            }

            // If ngized this could be so easy
            if((event.end  - event.start) <= 900000){
                element.find('span').removeClass('block');
            }else{
                element.find('span').addClass('block');
            }

            $scope.total = calendar.fullCalendar('clientEvents', function(event){
                return !event.existing || event.dirty;
            }).length;
        });

        $scope.$on($scope.SCHEDULER_NAMESPACE+'.eventAfterRender', function(ngEvent, event, element, view){
            var contentElm = element.find('.fc-event-content');
            var skipRemoveIcon = element.hasClass('candTimeslot');
            var evnt = event;
            if(contentElm.children('.ico-remove').length === 0 && !skipRemoveIcon){
                $('<a/>', {
                    'class' : 'right ico-remove',
                    'ng-click' : 'removeSchedule($event,"'+ evnt._id + '")'
                }).prependTo(contentElm);
            }
//            $scope.reRenderCalender();
            $compile(contentElm)($scope);
        });

        $scope.$on($scope.SCHEDULER_NAMESPACE+'.removeEvents', function(ngEvent, event, element, view){
            // Code smell : I think this entire function is redundant, check and remove.
            /*scope.total = calendar.fullCalendar("clientEvents", function(event){
            return !event.existing || event.dirty;
        }).length;*/
        });
        if (parseFloat(jQuery.fn.jquery) <= 1.3) {
            $(window).bind('beforeunload', $scope.hasChanged);
        } else {
            $(window).on('beforeunload', $scope.hasChanged);
        }
        //$('ul.tabs li').bind('click', $scope.hasChanged(true));
    };
}])

.directive('jvFreebusy', [function(){
    return function($scope, element, attrs){
        if(!$scope.freebusy){
            return;
        }
        function keepInSync() {
            var elements = [];
            var sync = function(e) {
                var target = e.target || e.srcElement;

                for (var k = 0, l = elements.length; k < l; k++) {
                    var element = elements[k];
                    if (element === target) {continue;}
                    element.scrollTop = target.scrollTop;
                    element.scrollLeft = target.scrollLeft;
                }
            };

            for (var k = 0, l = arguments.length; k < l; k++) {
                var element = arguments[k];
                if (document.addEventListener) {
                    element.addEventListener('scroll', sync);
                } else {
                    element.attachEvent('onscroll', sync);
                }
                elements.push(element);
            }
        }

        $scope.freebusy.options.eventRender = function(event, element, view){
            if(event.gcalEvent){
                if($scope.inPast(event.start)){
                    element.addClass('pastEvent');
                    element.html($('<div/>'));
                }else {
                    element.addClass('busyEvent');
                    element.html($('<div/>'));
                }
            }
            else{
                element.addClass('fc-event fc-event-skin fc-event-vert fc-event-draggable fc-corner-top fc-corner-bottom');
                element.html($('<div class="fc-event-inner fc-event-skin"/>'));
            }
        };

        var insertImages = function (resources) {
            angular.forEach(resources, function (resource) {
                var header;
                if (resource.user && !resource.user.hasOwnProperty('firstName')) {
                    return;
                }
                header = $('#resources table.fc-agenda-days thead tr th.fc-col' + resource.user.colIndex);
                if (resource.user.ProfilePictureUrl) {
                    header.prepend($('<img/>').attr('src', $scope.icon(resource.user))).wrapInner('<div/>');
                }
            });
        };

        var paginate = function (action) {
            if ($scope.freebusy.calendar) {
                $scope.freebusy.calendar.fullCalendar(action);
                insertImages($scope.freebusy.options.resources);
            }
        };

        if (parseFloat(jQuery.fn.jquery) <= 1.3) {
            $('.fc-button-prev .fc-button-content').bind('click', function () {
                paginate('prev');
            });

            $('.fc-button-next .fc-button-content').bind('click', function () {
                paginate('next');
            });

            $('#calendar .fc-button-today .fc-state-hover').bind('click', function () {
                if ($scope.freebusy.calendar) {
                    $scope.freebusy.calendar.fullCalendar('gotoDate', new Date());
                    insertImages($scope.freebusy.options.resources);
                }
            });
        } else {
            $('.fc-button-prev .fc-button-content').on('click', function () {
                paginate('prev');
            });

            $('.fc-button-next .fc-button-content').on('click', function () {
                paginate('next');
            });

            $('#calendar .fc-button-today .fc-state-hover').on('click', function () {
                if ($scope.freebusy.calendar) {
                    $scope.freebusy.calendar.fullCalendar('gotoDate', new Date());
                    insertImages($scope.freebusy.options.resources);
                }
            });
        }

        $scope.$on($scope.FREEBUSY_NAMESPACE+'.refresh', function(ngEvent, options){
            var copiedEvents = [], currDate, options, calendar, currDate;
            calendar = $scope.freebusy.calendar;
            //todo: is copying needed?
            angular.forEach(options.events, function(event){
                copiedEvents.push($scope.copyObj(event, ['start', 'end', 'allDay', 'title', 'origId', 'resourceId', 'gcalEvent']));
            });
            options.events = copiedEvents;
            // Remove this check
            if(calendar){
                calendar.fullCalendar('destroy');
                $scope.freebusy.calendar = null;
            }

            if(!$.isEmptyObject(options.resources) && options.resources.length > 0){ // Preventing the 'ownerDocument' error that happens on empty resources

                calendar = $scope.freebusy.calendar = $('#resources').fullCalendar(options);
                keepInSync($('#calendar div.fc-view-agendaDay > div > div').get(0), $('#resources .fc-view.fc-view-resourceDay.fc-agenda > div > div').get(0));

                if (options.resources.length > 4) {
                    $('#resources .fc-view.fc-view-resourceDay.fc-agenda > div > div').width(options.resources.length * 71);
                } else {
                    $('#resources .fc-view.fc-view-resourceDay.fc-agenda > div > div').width('100%');
                }

                // Hide the scrollbar of the scheduler
                //$('#calendar div.fc-view-agendaDay > div > div').css('overflow-y', 'hidden');

                currDate = $scope.currentDate();
                if(calendar.fullCalendar('getDate') != currDate){
                    calendar.fullCalendar('gotoDate', currDate);
                }
            }else{
                $('#calendar div.fc-view-agendaDay > div > div').css('overflow-y', 'auto');
            }
            $scope.reRenderCalender();
//            $('#calendar').fullCalendar('render');
        });

        $scope.$on($scope.SCHEDULER_NAMESPACE + '.gotoDate', function(ngEvent, date){
            if($scope.freebusy.calendar && !$scope.sameDay(date, $scope.freebusy.calendar.fullCalendar('getDate'))){
                $scope.freebusy.calendar.fullCalendar('gotoDate', date);
                insertImages($scope.freebusy.options.resources);
            }
        });

        $scope.$on($scope.FREEBUSY_NAMESPACE+'.created', function(ngEvent, calendarObj){
            insertImages($scope.freebusy.options.resources);
        });
    };
}])

/*
 *
 * Usage: <div jv-tinymce="newEmailContent" jv-tinymce-editable="editMode" ></div>
 *
 *
/*directive('jvTinymce', ['$timeout', function($timeout){

    var directiveObject ={
            restrict: 'A',
            template: '<textarea class="tinymce" ></textarea>',
            scope: {
                message: '=jvTinymce',
                editMode: '=jvTinymceEditable',
                renderOnLoad: '=jvRenderOnLoad',
                options: '=jvTinymceOptions',
                menubar:'=jvTinymceMenubar'
            },
            link: function(scope, element, attribute, controller){
                // create a temporary id for tinymce to internally keep track of it.
                _jvtinymcetempid =(typeof _jvtinymcetempid != "undefined" ?++_jvtinymcetempid: 0)
                 $(element).attr("id",_jvtinymcetempid);
                function fillValueInEditor(inst, message){
                    inst.execCommand('mceSetContent',false, message );
                }


                // Change, used only on the addition of the new email template.(Reflect back the changes to the scope from tinymce.)
                function detectChangesForTinymce(  ){
                    var inst = element.tinymce();
                    // for the addition of the email template section.
                    scope['message']['htmlMessage'] = inst.getContent();
                }

                // used when doing the html contents or editing. Used for initializing the tinymce with default contents inside.
                function fillValueForEditor( inst ){
                    inst = (!!inst? inst: element.tinymce());
                    //This will throw exception if called from the create new email template page.
                    if(!!scope.message && !!scope.message.htmlMessage){
                        fillValueInEditor(inst, scope.message.htmlMessage);
                    }
                    scope.$watch('message.htmlMessage', function(newValue,oldValue){
                        if(newValue===oldValue){
                            return;
                        }
                        fillValueInEditor(element.tinymce( ), newValue);
                    });
                }

                // VA: native ways of enabling and disabling tinymce are not tried and tested and there is no proper solution. Below way works best for enabling disabling.
                function enableTinymce(){
                    $($(element).parent()).find(".alpha60").remove();
                }

                function disableTinymce( id ){
                    // Only disable it for the email templates page and not the addition of templates page.
                    if(!!scope.newEmailContents){
                        return;
                    }
                }

                // This will keep track of the mode in which tinymce should work.
                scope.$watch('editMode', function(newValue, oldValue){
                    //disable or enable the rich text editor.
                    if(newValue === oldValue){
                        return;
                    }
                    if(newValue){
                        enableTinymce( );
                    }else{
                        disableTinymce();
                    }
                });

                function renderTinyMce(){

                    var options = {
                        // General options
                        mode : "exact",
                        elements : $(element).attr("id"),
                        theme : "modern",
                        plugins: [
                            "advlist autolink lists link image charmap print preview hr anchor pagebreak",
                            "searchreplace visualblocks visualchars code fullscreen",
                            "insertdatetime media nonbreaking save table contextmenu directionality",
                            "emoticons template paste textcolor"
                        ],
                        // toolbar1: "styleselect | fontselect | fontsizeselect | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | code | preview ",
                        // toolbar2: scope.options,
                        toolbar1: "styleselect | fontselect | fontsizeselect | bold italic | bullist numlist",
                        toolbar2: scope.options,
                        browser_spellcheck : true,
                        image_advtab: true,
                        height: (attribute.height || "240px"),
                        width: attribute.width,
                        plugin_preview_height: (attribute.height || "240px"),
                        plugin_preview_width: "990px",
                        content_css:"/__assets__/styles/tinymce-templates/jv.tinymce.css",
                        onchange_callback : detectChangesForTinymce,
                        valid_elements: '*[*]',
                        extended_valid_elements: '*[*]',
                        convert_urls: false,
                        menubar: scope.menubar,
                        setup: function( ed ){
                            element.tinymce = function(){
                                return ed;
                            };
                            ed.on('init',function() {
                                $(element.tinymce( ).getContainer()).find('iframe').droppable({
                                    drop: function(event, ui) {
                                        element.tinymce().execCommand('mceInsertContent',false, ui.draggable.data("content") );
                                    }
                                });
                            });
                            ed.on('BeforeSetContent',function(editor, o) {
                                if("<textarea class=\"tinymce\"></textarea>" !== editor.content) {
                                    scope.message.htmlMessage = editor.content;
                                }
                            });
                            ed.addButton('textAlign', {
                                type: 'menubutton',
                                icon: "alignleft",
                                tooltip: "Text Align",
                                context: "textAlign",
                                menu: [
                                    {
                                        text: 'align-left',
                                        icon: "alignleft",
                                        onclick: function() {
                                            ed.buttons.alignleft.onclick();
                                        }
                                    },
                                    {
                                        text: 'align-right',
                                        icon: "alignright",
                                        onclick: function() {
                                            ed.buttons.alignright.onclick();
                                        }
                                    },
                                    {
                                        text: 'align-justify',
                                        icon: 'alignjustify',
                                        onclick: function() {
                                            tinyMCE.activeEditor.buttons.alignjustify.onclick();
                                        }
                                    },
                                    {
                                        text: 'align-center',
                                        icon: 'aligncenter',
                                        onclick: function() {
                                            tinyMCE.activeEditor.buttons.aligncenter.onclick();
                                        }
                                    }
                                ]
                            });
                        },
                        oninit: fillValueForEditor,
                        setupcontent_callback : function(){
                            (attribute['disableOnStart'] ? disableTinymce : angular.noop)();
                        }
                    };

                    if(angular.isString(attribute.jvTinymceWidth)) {
                            options.width = attribute.jvTinymceWidth;
                    }
                    var tinymceRef = tinyMCE.init(options);
                }

                //optimization as the loading of multiple tinymce was killing the pages.
                if(typeof scope['renderOnLoad'] !="undefined" && scope['renderOnLoad'] == false ){
                    scope.$watch('renderOnLoad', function( newValue ){
                        if(newValue == true){
                            renderTinyMce();
                            renderTinyMce = function(){};
                        }

                    });
                }else{
                    renderTinyMce();
                }
            }
    };
    return directiveObject;
}]).*/

    .directive('jvTinymceDraggable', ['$compile', function($compile) {
        return {
            link: function(scope, element, attr) {
                    $(element).draggable({
                    revert: false,
                    addClasses: false,
                    cursor: 'default',
                    helper: 'clone',
                    iframeFix: true,
                    opacity: 0.90,
                    //refreshPositions: true,
                    appendTo: 'body'
                    });
                scope.$watch('content', function(val) {
                    if (angular.isDefined(val)) {
                        $(element).data('content', val);
                    }
                });
                if (angular.isDefined(attr.editLink)) {
                    var editLink = angular.element('<a href="javascript: void(0)" ng-click="editLink()">edit</a>');
                    $(element).append($compile(editLink)(scope));
                }
            },
            scope: {
                content: '@',
                title: '@',
                editLink: '&'
            },
            template:'{{title}}'
        };
    }])

    .factory('Draggable', ['draggableTemplate', function(draggableTemplate) {
        return  function( textToShow, content, metaData ) {
            var object = { };
            object.text = textToShow;
            object.content = draggableTemplate(content);
            object.metadata = angular.extend(metaData || {}, {templateVariable: content});
            return object;
        };
    }])


.directive('jvBarChart', ['jvHireUrlService', function (jvHireUrlService) {
    var barChartConfig = {
            scope: {
                    requisitions: '=jvBarChart',
                    bandHeight: '=jvBarChartBandheight',
                    bandWidth: '=jvBarChartBandWidth',
            },
            link: function (scope, elm, attrs) {
                    var categories = [];
                    var data = [];
                    var height;
                    var bandHeight = scope.bandHeight || 25;
                    var labelSetup = {};
                    var eidSetup = {};
                    var longestLength = 0;
                    var firstCol, tableWidth;
                    var longestColumn = 1;

                    function getApplicationSearchUrl(jobId, jobName, workflowId) {
                        if (angular.isDefined(properties)) {
                            return jvHireUrlService.getCandidateListPageUrl({
                                jobIds: jobId,
                                jobName: encodeURIComponent(jobName),
                                workflowStateIds: encodeURIComponent(workflowId)
                            });
                        }
                    }

                    for(var workflowStep in scope.requisitions.candidateWorkFlowSteps) {
                        for(var workflowState in scope.requisitions.candidateWorkFlowStates) {
                            if(workflowStep === scope.requisitions.candidateWorkFlowStates[workflowState].EId) {
                                categories.push(scope.requisitions.candidateWorkFlowStates[workflowState].name);
                                eidSetup[scope.requisitions.candidateWorkFlowStates[workflowState].name] = workflowStep;
                                data.push(scope.requisitions.candidateWorkFlowSteps[workflowStep]);
                                labelSetup[scope.requisitions.candidateWorkFlowStates[workflowState].name] = scope.requisitions.candidateWorkFlowSteps[workflowStep];
                                break;
                            }
                        }
                    }
                    for(var i in categories) {
                        if(categories[i].length > longestLength) {
                            longestLength = categories[i].length;
                        }
                    }
                    for(var j in labelSetup) {
                        if(labelSetup[j] > longestColumn) {
                            longestColumn = labelSetup[j];
                        }
                    }
                    firstCol = longestLength * 11;
                    tableWidth = firstCol + 35 + scope.bandWidth;
                    if(tableWidth > (270 + scope.bandWidth)) {
                        tableWidth = 270 + scope.bandWidth;
                        firstCol = 165;
                    }

                    height = (bandHeight + 20) * categories.length;

                    var _brandFont = '';
                    if (typeof _HRTECHUI_ENABLED !== 'undefined' && _HRTECHUI_ENABLED){
                        _brandFont = 'Helvetica Neue LT Std 45 Light, Segoe UI';
                    } else {
                        _brandFont = 'Arial,Helvetica,sans-serif,Trebuchet MS,Trebuchet,Verdana';
                    }
                    $(elm).highcharts({
                        title: {
                            text: ''
                        },
                        chart: {
                            type: 'bar',
                            height: height
                        },
                        colors: ['#30b545'],
                        tooltip: {
                            enabled: false
                        },
                        credits: {
                            enabled: false
                        },
                        xAxis: {
                            categories: categories,
                            gridLineWidth: 1,
                            gridLineColor: '#E0E0E0',
                            tickLength: 250,
                            lineWidth: 0,
                            tickColor: '#FFFFFF',
                            labels: {
                                useHTML: true,
                                formatter: function () {
                                    var url = getApplicationSearchUrl(scope.requisitions.jobDetails.EId, scope.requisitions.jobDetails.title, this.value);
                                    var returnValue = "<table style='width: "+tableWidth+"px !important;' class='barChartTable'><col width='"+firstCol+"'><col width='35'><tr><td title='"+this.value+"' align='left' class='barChartLabel truncateLabel'>"+this.value+"</td><td style='text-align: right;padding-right:0px; vertical-align: middle; padding-top: 6px'><a href=\""+url+'">'+labelSetup[this.value]+'</a></td></tr></table>';
                                    return returnValue;
                                },
                                enabled: true,
                                style:{
                                    whiteSpace:'normal'
                                }
                            }
                        },
                        yAxis: {
                            gridLineWidth: 0,
                            max: longestColumn,
                            title: {
                                text: ''
                            },
                            labels: {
                                enabled: false
                            }
                        },
                        series: [{
                            data: data
                        }],
                        legend: {
                            enabled: false
                        },
                        plotOptions: {
                            series: {
                                cursor: 'pointer',
                                pointWidth: bandHeight,
                                point: {
                                    events: {
                                        click: function () {
                                            window.open(getApplicationSearchUrl(scope.requisitions.jobDetails.EId, scope.requisitions.jobDetails.title, this.category), '_self');
                                        }
                                    }
                                }
                            }
                        }
                    });
            }
     };
    return barChartConfig;
}])

.directive('jvPieChart', ['$rootScope', function(rootScope) {
    var configPieChart = {
                            scope: {
                                appSource: '=jvPieChart',
                                sourceType: '=jvPieChartSource',
                                chartTitle: '@jvPieChartTitle'
                            },
                            link: function(scope, linkElement, attrs) {
                                    var colorCodes = [];
                                    var tempData = [];
                                    var zerothData;
                                    var chartData = [];
                                    var gatheredData = [];
                                    var distance;
                                    var legendEnabled = true;
                                    var applicationsBySource;
                                    //BE Sends Sorted Data On Chrome But Not On Firefox. So Sorting The Data Always To Ensure Same Result On All Browsers
                                    applicationsBySource = rootScope.sortObjByKey(scope.appSource);

                                    if(typeof _HRTECHUI_ENABLED !== 'undefined' && _HRTECHUI_ENABLED){
                                        colorCodes =  ['#f01978','#3d87cf','#30b545','#7354bd','#f57d21'];
                                    }else{
                                        colorCodes = [ '#7ac843', '#ff921e', '#9ee46f','#3da9f5', '#7fd0ff' ];
                                    }

                                    //Mysterious index 0 is sent by BE to indicate other sources. So we need to gather them as there is no source for 0 in source type
                                    if(applicationsBySource.hasOwnProperty(0)) {
                                        zerothData = applicationsBySource[0];
                                        delete applicationsBySource[0];
                                    }
                                    for(count in applicationsBySource) {
                                        tempData = [];
                                        tempData[0] = scope.sourceType[count].name;
                                        tempData[1] = applicationsBySource[count];
                                        gatheredData.push(tempData);
                                    }

                                    //If the number of sources are high, we need to make the last few items after the 4th index as others to make it more viewable for the user
                                    if(gatheredData.length > 3) {
                                        for(var i = 0; i < 4; i++) {
                                            chartData.push(gatheredData[i]);
                                        }
                                        tempData = [];
                                        tempData[0] = 'Others';
                                        tempData[1] = 0;
                                        for(var i = 4; i < gatheredData.length; i++) {
                                            tempData[1] += gatheredData[i][1];
                                        }
                                        //Add the zeroth index to others for display
                                        if(zerothData) {
                                            tempData[1] += zerothData;
                                        }
                                        chartData.push(tempData);
                                    } else {
                                        chartData = gatheredData;
                                    }

                                    //Handle the case where there is no data sent by the BE
                                    if(!chartData.length) {
                                        tempArray = [];
                                        tempArray[0] = i18n.REQ_DETAILS_SUMMARY_ANALYTICS_CHART_NODATA;
                                        tempArray[1] = 1;
                                        chartData.push(tempArray);
                                        colorCodes = ['#DDDDDD'];
                                        distance = -70;
                                        legendEnabled = false;
                                    } else {
                                        distance = -20;
                                    }

                                    var height = 260 + (chartData.length * 16);

                                    $('#'+attrs.id).highcharts({
                                        chart: {
                                            plotBackgroundColor: null,
                                            plotBorderWidth: null,
                                            plotShadow: false,
                                            height: height,
                                            width: 285
                                        },
                                        title: {
                                            align: 'left',
                                            text: scope.chartTitle
                                        },
                                        exporting: {
                                            enabled: false
                                        },
                                        plotOptions: {
                                            pie: {
                                                allowPointSelect: true,
                                                enableMouseTracking: true,
                                                cursor: 'pointer',
                                                dataLabels: {
                                                    color: 'white',
                                                    style: {fontWeight:'bold'},
                                                    enabled: true,
                                                    crop: false,
                                                    distance: distance,
                                                    useHTML: true,
                                                    formatter: function () {
                                                        var returnVal = '';
                                                        if(legendEnabled) {
                                                            if(this.percentage > 4) {
                                                                returnVal = '<span>'+Math.round(this.percentage)+' %</span>';
                                                            }
                                                        } else {
                                                            returnVal = "<span style='font-size: 14px;'>"+i18n.REQ_DETAILS_SUMMARY_ANALYTICS_CHART_NODATA;+'</span>';
                                                        }
                                                        return returnVal;
                                                    }
                                                },
                                                states: {
                                                    hover: {
                                                        brightness: 0
                                                    }
                                                },
                                                slicedOffset: 0,
                                                showInLegend: true,
                                                colors: colorCodes
                                            }
                                        },
                                        series: [{
                                            type: 'pie',
                                            name: 'Source Share',
                                            data: chartData
                                        }],
                                        credits: {
                                            enabled: false
                                        },
                                        legend: {
                                            enabled: legendEnabled,
                                            layout: 'vertical',
                                            borderWidth: 0
                                        },
                                        tooltip: {
                                            enabled: legendEnabled
                                        }
                                    });
                                }
                           };
    return configPieChart;
}])

/*
 * Model refreshing issue's fix for IE8
 */
.directive('jvBlurFocus', [function(){
    return function(scope, elm, attrs) {
        elm.on('click', function(){
            elm.trigger('blur');
            elm.trigger('focus');
        });
    };
}])
/*
 * This directive has been created to clear the attchement section's markup
 */
.directive('jvAttachClear', [function(){
    return function(scope, elm, attrs) {
        scope.attachClear=function(){
            elm.find('.qq-upload-list').html('');
        };
    };
}])
/*
 * This directive has been created to resolve the "undefined" issue of select2 dropdownbox/ng-model. Where ever ui-select2 is used , use this directive to overcome the 'undefined' issue.
 */
.directive('jvResetModel', [function(){
    return {
        require: '?ngModel',
        link:function(scope, elm, attrs,ctrl) {
            elm.click(function(){
                if(ctrl.$modelValue===undefined){
                    ctrl.$setViewValue(' ');//setting empty string to ng-model
                }
            });
        }
    };
}])
/**
 * jv:warnDirty directive is used to show a confirmation message when the user
 * navigates away from the page and the form is dirty.
 *
 * @param [message] {string} Optional message to show. Default i18n.NAV_AWAY_WARNING_MESSAGE
 **/
.directive('jvWarndirty', ['$window', function(window) {
    return {
        require: 'form',
        link: function(scope, elm, attrs, ctrl) {
            var message = attrs.jvWarndirty || ( (window.i18n) ? window.i18n.NAV_AWAY_WARNING_MESSAGE : '' ),
            dirtyCheck = (function(ctrl, message) {
                return function(){
                    var check = (attrs.jvWarndirtyCheck) ? scope.$eval(attrs.jvWarndirtyCheck) : true;
                    if (check && ctrl.$dirty) {
                        return message;
                    }
                };
            }(ctrl, message));

            // can be removed if check is no longer needed
            ctrl.removeWarnDirty = function() {
                $(window).off('beforeunload', dirtyCheck);
            };

            $(window).on('beforeunload', dirtyCheck);
        }
    };
}])
/*
 * directive to open links in a seperate tab.
 */
.directive('jvOnPreviewFrameLoad',[function() {
   return  {
             scope: {
             },
             link: function(scope, element, attrs){
                 element.on('load', function(){
                     element.contents().find('a').not( '[href^="mailto:"]' ).not( '[href^="tel:"]').attr('target','_blank');
                 });
             }
          };
}])
    /*@_directive to control NavAway message by setting up scope b
    *
    ***/
    .directive('jvNavaway', ['$window', function($window) {
        return {
            require: 'form',
            restrict:'A',

            compile: function(templateElemnt){
                /*removing onclick events in top-navigation which is setting window.location and causing window.befoeUnload event to echo*/
                /*TODO: .net navigation should change to remove onlclick event*/
                var navElement=document.getElementById('hr-navWrapper');
                if(navElement){
                    $(navElement).find('li').each(function(index){
                        if(this.onclick){
                            var captureUrl=this.onclick.toString().split('"');
                            if(captureUrl.length==3){
                                var actualLink=$(this).find('a');
                                if(actualLink.length){
                                    $(this).removeAttr('onclick');
                                    $(actualLink).removeAttr('onclick');
                                    $(actualLink).attr('href',captureUrl[1]);
                                }
                            }
                        }
                    });
                }
                /*link function*/
                return function(scope, elm, attrs, ctrl) {
                    var message = attrs.jvNavaway || ( (window.i18n) ? window.i18n.NAV_AWAY_WARNING_MESSAGE : '' );
                    if(attrs.jvnavawayflag){
                    /*@_object to store all navAway check flags on page*/
                        window.allNavAwayFlagsOnPage=window.allNavAwayFlagsOnPage||{};
                        /*@_pushing flag with current value to this object if doesn't exist!*/
                        if(!window.allNavAwayFlagsOnPage[attrs.jvnavawayflag]){
                            window.allNavAwayFlagsOnPage[attrs.jvnavawayflag]= scope.$eval(attrs.jvnavawayflag);
                        }

                        /*@_adding a watch to every flag passed to capture the form state*/
                        scope.$watch(attrs.jvnavawayflag, function(newVal, oldVal){
                            /*@_updating new value to object*/
                            var startNavAway=newVal;
                            window.allNavAwayFlagsOnPage[attrs.jvnavawayflag]=newVal;

                            /*@_checking if any of the form flag is on*/
                            angular.forEach(window.allNavAwayFlagsOnPage, function(flag, index){
                                startNavAway |= flag;
                            });

                            /*@_bind 'beforeunload' event only if any of the form's flag is set. else unbind the event*/
                            if (startNavAway && !window.navAwayGlobalObj) {
                               window.navAwayGlobalObj=$(window).on('beforeunload', function(e){
                                    window.navAwayFlagArray={};
                                    return message;
                                });
                            } else {
                                if (parseFloat(jQuery.fn.jquery) <= 1.3) {
                                    $(window).unbind('beforeunload');
                                } else {
                                    $(window).off('beforeunload');
                                }
                               delete window.navAwayGlobalObj;
                            }
                        });
                    }
                };
            }
        };
    }])
   /// TODO (MikeMac): Refactor this to DRY.
    .factory('isIE', ['$window', function($window) {
        if($window.addEventListener) {
            return false;
        }
        return true;
    }])
    .factory('addEventListener', ['isIE', function(isIE) {
        var _toAttach = angular.noop,
            _prefix = angular.identity;
        if(!isIE) {
            _toAttach = 'addEventListener';
            _prefix = angular.identity;
        } else {
            _toAttach = 'attachEvent';
            _prefix = function(val) { return 'on' + val; };
        }

        var _attach = function(val, cb, capture) {
            this[_toAttach](_prefix(val), cb, capture || false);
        };

        return function(el) {
            return angular.bind(el, _attach);
        };
    }])
    /// TODO (MikeMac): Refactor this to DRY.
    .factory('removeEventListener', ['isIE', function(isIE) {
        var _toAttach = angular.noop,
            _prefix = angular.identity;
        if(!isIE) {
            _toAttach = 'removeEventListener';
            _prefix = angular.identity;
        } else {
            _toAttach = 'detachEvent';
            _prefix = function(val) { return 'on' + val; };
        }

        var _attach = function(val, cb, capture) {
            this[_toAttach](_prefix(val), cb, capture || false);
        };

        return function(el) {
            return angular.bind(el, _attach);
        };
    }])
    .factory('bindAndUnbindClickToDocument', ['$document', 'addEventListener', 'removeEventListener', function($document, addEvent, removeEvent) {
        return function bindAndUnbindClickToDocument (el, action) {
            var _doc = $document[0];
            var _outsideHandler = function(ev) {
                action();
                removeEvent(_doc)('click', _outsideHandler, true);
            };
            addEvent(_doc)('click', _outsideHandler, true);
        };
    }])
    .factory('stopPropagation', ['isIE', function(isIE) {
        if(isIE) {
            return function(event) {
                event.cancelBubble = true;
            };
        } else {
            return function(event) {
                event.stopPropagation();
                event.stopImmediatePropagation();
            };
        }
    }])
    .factory('addClick', ['bindAndUnbindClickToDocument', 'addEventListener', 'stopPropagation', function(docMagic, addEvent, stopPropagation) {
        return function addClick(el, activate, deactivate) {
            addEvent(el[0])('click', function(ev) {
                docMagic(el, deactivate);
                activate();
                // stopPropagation(ev);
            }, true);
        };
    }])
    .factory('addMouseover', [function () {
        return function addMouseover(el, activate, deactivate) {
            if (parseFloat(jQuery.fn.jquery) >= 1.7) {
                el.on('mouseover', function() {
                    activate();
                });
                el.on('mouseout', function() {
                    deactivate();
                });
            } else {
                el.bind('mouseover', function() {
                    activate();
                });
                el.bind('mouseout', function() {
                    deactivate();
                });
            }
        };
    }])
    .directive('tooltip', ['$compile', 'addClick', 'addMouseover', 'bindAndUnbindClickToDocument', function($compile, addClick, addMouseover, docMagic) {
        return {
            replace: true,
            scope: true,
            compile: function(tEl, tAttr) {
                var _trigger = tEl.find('[tooltip-trigger]'), trigger = _trigger.html(),
                    _title = tEl.find('[tooltip-title]'), _title_exists = (_title.length > 0), title = _title.html(),
                    _body = tEl.find('[tooltip-body]'), body = _body.html();
                _trigger.remove();
                _title.remove();
                _body.remove();
                return {
                    pre: function(scope, el, attr) {
                    function tooltipAppear() {
                        scope.__showTooltip__ = true;
                    }
                    function tooltipDisappear() {
                        scope.__showTooltip__ = false;
                    }
                    function tooltipAppearWithApply() {
                        scope.$apply(tooltipAppear);
                    }
                    function tooltipDisappearWithApply() {
                        scope.$apply(tooltipDisappear);
                    }

                    var triggerHtml = angular.element(trigger),
                        tooltip = angular.element('<div class="tooltipWindow" ng-show="__showTooltip__"' + (attr.ngAnimate ? ' ng-animate="' + attr.ngAnimate + '"' : '') + '></div>'),
                        tooltipContainer = angular.element('<div class="tooltipContainer"></div>'),
                        titleEl = angular.element('<div class="title">' + title + '</div>'),
                        bodyEl = angular.element('<div class="body">' + body + '</div>');
                        var setEvents = ((angular.isDefined(attr.$attr.showonhover) && attr.$attr.showonhover !== 'false') ? addMouseover : addClick);


                    if(angular.isDefined(attr.show)) {
                        scope.$watch(attr.show, function(newVal) {
                            if(newVal) {
                                docMagic(el, function() {
                                    scope.$parent[attr.show] = false;
                                    tooltipDisappearWithApply();
                                });
                                tooltipAppear();
                            }
                        });
                    }

                    scope.__showTooltip__ = false;
                    el.append($compile(triggerHtml)(scope));
                    if (_title_exists) {
                        tooltipContainer.append(titleEl);
                    }
                    tooltipContainer.append(bodyEl);
                    tooltip.append(tooltipContainer);

                    el.append($compile(tooltip)(scope));

                    setEvents(el, tooltipAppearWithApply, tooltipDisappearWithApply);
                },
                post: angular.noop
                };
            }
        };
    }])
    /*
        scroll to error
    */
    .directive('jvScrollError', ['$timeout', function($timeout){
        return function(scope, elm, attrs) {
            const submitHandler = function() {
                var form=$(this);
                // To overcome Firefox scroll issue
                $timeout(function(){
                    if(form.find('label.required.error').length){
                        var top = form.find('label.required.error').eq(0).offset().top;
                        $('html,body').animate({ scrollTop: top }, 400);
                    }
                },0);
            };
            if (parseFloat(jQuery.fn.jquery) > 1.3) {
                elm.on('submit', submitHandler);
            } else {
                elm.submit(submitHandler);
            }
        };
    }])
    .directive('placeholder', ['$compile', function($compile){
        if(('placeholder' in $('<input>')[0] || 'placeHolder' in $('<input>')[0])){
            // don't run the polyfill when the browser has native support
            return angular.noop;
        }

        return {
            priority: -1,
            require: 'ngModel',
            link: function($scope, iElm, iAttrs) {
                if (!iElm.is('input') || iAttrs.uiSelect2) {
                    return;
                }

                var placeholder = $('<span ng-show="!'+iAttrs.ngModel+'" />')
                    .addClass('jv-placeholder')
                    .click(function() {
                        iElm.focus();
                    });

                iAttrs.$observe('placeholder', function(val) {
                    placeholder.text(val);
                });

                if (!iElm.parent().is('.ui-resetwrap') && !iElm.parent().is('.jv-resetwrap')) {
                    iElm.wrap('<div class="jv-placeholderwrap" />');
                }

                iElm.after($compile(placeholder)($scope));
            }
        };
    }]);
